export type OrderCustomerType = "consumer" | "business";

export type OrderConsentPayload = {
  customerType: OrderCustomerType | "";
};

export const defaultOrderConsentPayload: OrderConsentPayload = {
  // B2B-only Checkout: wir behandeln alle Bestellungen als Unternehmergeschäft.
  customerType: "business",
};

export function getMissingOrderConsentLabels(value: OrderConsentPayload) {
  const missing: string[] = [];

  if (!value.customerType) {
    missing.push("Kundentyp");
  }

  return missing;
}

export function isOrderConsentComplete(value: OrderConsentPayload) {
  return getMissingOrderConsentLabels(value).length === 0;
}
